import project1 from "../assets/projects/project-1.jpg";
import project2 from "../assets/projects/project-2.jpg";

export const HERO_CONTENT = `Life's a journey, and I'm just here to render it beautifully!`;

export const ABOUT_TEXT = `Hey there! I’m Navneet Uniyal, a passionate web developer from the beautiful Uttarakhand, India. I thrive on coding and love diving into new technologies to enhance my skills. I’m always excited to connect with fellow tech enthusiasts—let’s grab a coffee and share ideas!`;

export const EXPERIENCES = [
  {
    year: "Jan 2025 - Present ",
    role: "Senior Software Developer",
    company: "Hexagon Capability Center India Private Limited",
    description: `At Hexagon, I'm contributing to a product focused on public safety, which is giving me hands-on experience with how product-based companies operate at scale. I'm learning how large teams collaborate across departments, manage complex project lifecycles, and maintain high standards for product quality and user impact. `,
    technologies: ["Javascript", "React.js", "C#", "Github", "Azure"],
  },
  {
    year: "Aug 2022 - Dec 2024",
    role: "Software Developer Frontend",
    company: "KiwiTech",
    description: `I have worked on a variety of projects, gaining experience with diverse technologies such as React and Next.js. Throughout my career, I have collaborated closely with business analysts, participated in client meetings, and managed individual projects. This exposure has significantly enriched my understanding of React, and I am committed to continuous learning and improvement in this area.`,
    technologies: [
      "Javascript",
      "React.js",
      "Next.js",
      "firebase",
      "git",
      "Github",
      "Jira",
    ],
  },
  {
    year: "Mar 2021 - Aug 2022",
    role: "Associate Software Developer",
    company: "Capgemini",
    description: `I started my career as an Associate Software Developer at Capgemini, where I gained a solid understanding of how projects work from the ground up. It was there that I was introduced to front-end technologies like React, which really sparked my passion for creating dynamic and user-friendly applications. My experience at Capgemini not only sharpened my technical skills but also taught me the importance of collaboration and best practices in software development.`,
    technologies: ["HTML", "CSS", "React", "Babel", "Redux"],
  },
];

export const PROJECTS = [
  {
    title: "GrowMe (Client Project)",
    image: project1,
    description: `Grow Me was a platform designed specifically for students aiming for admission to foreign universities. The primary target audience was students preparing to study abroad, with three main user roles: students, teachers, and parents.
In this platform, teachers could engage directly with students and parents, assign tasks, review assignments, and provide valuable feedback. The app also tracked students’ progress, supporting them throughout their university preparation journey. With its structured approach, Grow Me offered a comprehensive support system, empowering students to reach their academic goals with the guidance and involvement`,
    technologies: [
      "HTML",
      "CSS",
      "Next js",
      "Redux",
      "Stripe",
      "SSO google",
      "firebase",
    ],
  },
  {
    title: "Erloom (Client Project)",
    image: project2,
    description:
      "Erloom - Collaborated with a team to develop an interactive platform designed to preserve and share cherished family memories across generations. The site bridges past and present by allowing users to keep the legacy of loved ones alive through engaging, story-driven connections.",
    technologies: ["HTML", "CSS", "React"],
  },
];

export const CONTACT = {
  address: "Dehradun, Uttarakhand",
  email: "navneetuniyal098@gmail.com",
};

export const ARR_WHO_I_AM = [
  "Front end developer",
  "Photographer",
  "Proud Indian",
];
